import type { FormSchema, GeneratorOptions } from '@cli-types/core-engine/schema.js'
import type { FormNavigationResult } from '@cli-types/next-adapter/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { toKebabCase } from '@cli-utils/text.js'
import { buildNavigationExtractSource } from '@next-adapter/generators/navigation-extract.js'

export function updateFormNavigation(
  schema: FormSchema,
  navigationDir: string,
  options: GeneratorOptions = {}
): FormNavigationResult {
  const adminRoutePath = options.adminRoutePath ?? '/admin'

  const content = buildNavigationExtractSource(schema.name, {
    label: schema.label,
    href: `${adminRoutePath}/forms/${toKebabCase(schema.name)}`,
    icon: schema.icon || 'Inbox',
    group: schema.navGroup?.label ?? 'Forms',
    groupIcon: schema.navGroup?.icon ?? 'Inbox',
    groupPosition: schema.navGroup?.position,
    position: schema.navPosition
  })

  return {
    files: [createGeneratedFile(`${navigationDir}/${schema.name}.ts`, content)]
  }
}
